/* Fades [data-ly-reveal] elements in and up as they enter the viewport.
   .ly-reveal-ready (the hidden state) is only added when the reveal is
   guaranteed to run, so nothing can get stuck invisible. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ly-reveal-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  function watch(scope) {
    scope.querySelectorAll('[data-ly-reveal]').forEach(function (el) {
      if (el.classList.contains('ly-reveal-ready')) return;
      el.classList.add('ly-reveal-ready');
      observer.observe(el);
    });
  }

  watch(document);

  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();
